import type React from 'react';
import type { Conversation } from '../../../api/types';
import { ConversationListSkeleton } from '../LoadingSkeleton';
import styles from './ConversationList.module.css';

export interface ConversationListProps {
  conversations: Conversation[];
  currentConversation: Conversation | null;
  onSelect: (conversation: Conversation) => void;
  onNew: () => void;
  isLoading?: boolean;
}

export const ConversationList: React.FC<ConversationListProps> = ({
  conversations,
  currentConversation,
  onSelect,
  onNew,
  isLoading = false,
}) => {
  return (
    <div className={styles.conversationList}>
      <div className={styles.conversationListHeader}>
        <h3>Conversations</h3>
        <button
          className={styles.newConversationButton}
          onClick={onNew}
          aria-label="New conversation"
        >
          + New
        </button>
      </div>

      <div className={styles.conversations}>
        {isLoading && conversations.length === 0 ? (
          <ConversationListSkeleton count={5} />
        ) : conversations.length === 0 ? (
          <div className={styles.emptyConversations}>
            <p>No conversations yet.</p>
            <p>Click "+ New" to start!</p>
          </div>
        ) : (
          conversations.map((conv) => (
            <div
              key={conv.conversation_id}
              className={`${styles.conversationItem} ${
                currentConversation?.conversation_id === conv.conversation_id ? styles.active : ''
              }`}
              onClick={() => onSelect(conv)}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  onSelect(conv);
                }
              }}
              aria-label={`Select conversation: ${conv.title}`}
            >
              <div className={styles.conversationTitle}>{conv.title}</div>
              <div className={styles.conversationDate}>
                {new Date(conv.updated_at).toLocaleDateString()}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
